import React from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import AnchorScrollNavbar from 'components/AnchorScrollNavbar'

export const AboutAnchorScrollNavbar = (props: any) => {
    const breakpoints = useBreakpoint()
    return (
        <div className="about-nav sticky -top-1 z-10 mb-6 border-y border-dashed border-gray-accent-light bg-red py-2 backdrop-blur">
            <AnchorScrollNavbar autoScroll={breakpoints.md} className="mx-auto max-w-screen-xl lg:px-8" {...props} />
        </div>
    )
}
